import { cn } from '@goaltree/ui/lib/utils'
import { Mic } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { IconTip } from '@/components/icon-tip'
import { useIsCoaching } from '@/lib/coaching-mode'
import { openCapture } from '@/store/capture.store'

// Desktop header mic on Today and Everyday (phones get it above the + button). openCapture shows the Pro gate to free users.
export function BrainDumpHeaderButton({ className }: { className?: string }) {
  const { t } = useTranslation()
  const coaching = useIsCoaching()
  if (coaching) return null
  return (
    <IconTip label={t('voice.title')}>
      <button
        type="button"
        onClick={openCapture}
        aria-label={t('voice.title')}
        className={cn(
          'flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-md text-primary-text transition-colors hover:bg-primary/10',
          className,
        )}
      >
        <Mic className="h-5 w-5" strokeWidth={1.75} />
      </button>
    </IconTip>
  )
}

// Small "Too much on your mind?" link under an empty or finished Today.
export function BrainDumpEmptyAction({ className }: { className?: string }) {
  const { t } = useTranslation()
  const coaching = useIsCoaching()
  if (coaching) return null
  return (
    <div className={cn('flex justify-center', className)}>
      <button
        type="button"
        onClick={openCapture}
        className="flex cursor-pointer items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-medium text-muted-foreground transition-colors hover:bg-primary/10 hover:text-primary-text"
      >
        <Mic className="h-4 w-4 text-primary-text" strokeWidth={2.25} />
        {t('voice.emptyTodayAction')}
      </button>
    </div>
  )
}
